// formConfigs/userManagementConfig.js
import * as Yup from "yup";
import { NOSPACE_REGEX } from "../../utils/constants";
import { MESSAGE } from "../../utils/validationMessage";
import { STATUS_OPTIONS_LIST } from "../../utils/constants";

export const userManagementFormConfig = {
  fields: [
    {
      name: "name",
      label: "Name",
      type: "text",
      gridSize: 4,
      required: true,
    },
    {
      name: "address",
      label: "Address",
      type: "text",
      gridSize: 4,
      required: true,
    },
    {
      name: "city",
      label: "City",
      type: "text",
      gridSize: 4,
      required: true,
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      gridSize: 4,
      options: STATUS_OPTIONS_LIST,
      native: true,
      required: true,
    },
  ],
  
  validationSchema: Yup.object({
    name: Yup.string()
      .min(2, "Name must be at least 2 characters")
      .max(60, "Name should not be longer than 60 characters")
      .required(MESSAGE.REQUIRED)
      .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE),
    address: Yup.string()
      .required(MESSAGE.REQUIRED)
      .min(10, "Address must be at least 10 characters")
      .max(100, "Address should not be longer than 100 characters")
      .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE),
    city: Yup.string().required("City is required"),
    status: Yup.string().required("Status is required"),
  }),

  getInitialValues: (data) => ({
    name: data?.name || "",
    address: data?.address || "",
    city: data?.city || "",
    status: data?.status || "",
  }),
};

// Alternative configuration for a different form (example)
export const profileFormConfig = {
  fields: [
    {
      name: "firstName",
      label: "First Name",
      type: "text",
      gridSize: 6,
      required: true,
    },
    {
      name: "lastName",
      label: "Last Name",
      type: "text",
      gridSize: 6,
      required: true,
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      gridSize: 12,
      required: true,
    },
    {
      name: "bio",
      label: "Bio",
      type: "text",
      gridSize: 12,
      multiline: true,
      rows: 4,
    },
  ],
  
  validationSchema: Yup.object({
    firstName: Yup.string()
      .min(2, "First name must be at least 2 characters")
      .required("First name is required"),
    lastName: Yup.string()
      .min(2, "Last name must be at least 2 characters")
      .required("Last name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    bio: Yup.string()
      .max(500, "Bio should not exceed 500 characters"),
  }),

  getInitialValues: (data) => ({
    firstName: data?.firstName || "",
    lastName: data?.lastName || "",
    email: data?.email || "",
    bio: data?.bio || "",
  }),
};